/* SPECSBYLUX Rx configurator — loaded by sections/rx-configurator.liquid (asset: sbl-rx-app.js) */
(function () {
  'use strict';

  var CODE_BY_SKU = { 'LENS-VIS-SV': 'sv', 'LENS-VIS-PROG': 'prog', 'LENS-VIS-RDR': 'readers', 'LENS-VIS-PLANO': 'plano',
    'LENS-SUN-SV': 'sv', 'LENS-SUN-PROG': 'prog', 'LENS-SUN-RDR': 'readers', 'LENS-SUN-PLANO': 'plano' };
  var CODE_BY_LABEL = { 'single vision': 'sv', 'progressive': 'prog', 'readers': 'readers', 'non-prescription': 'plano' };
  var READER_POWERS = ['+1.00', '+1.25', '+1.50', '+1.75', '+2.00', '+2.25', '+2.50', '+2.75', '+3.00', '+3.25', '+3.50'];
  var READER_POWERS_SUN = READER_POWERS.concat(['+3.75', '+4.00']);

  // ---- SUNSPECS lens color chart (edit here: name, color top, color bottom) ----
  var SUN_POL = [['grey', 'Grey', '#3B4146'], ['brown', 'Brown', '#6B4A33'], ['green', 'Green', '#3F4F3A']];
  var SUN_TINTS = {"solid": [["Gray 1", "#7E9496"], ["Gray 3", "#5C6670"], ["Brown 1", "#B8874E"], ["Brown 3", "#9E7A4A"], ["Gray Green", "#4E7046"], ["Plum", "#6A2A55"], ["Gray Mist", "#7B8582"], ["Forest Gray", "#5F7258"], ["Sienna Brown", "#6E4A3C"], ["Grape", "#4B2F7E"], ["Ruby", "#8E3A3E"], ["Emerald Blue", "#2F6B66"], ["Copper", "#A95E2C"]], "gradient": [["Gray Mist", "#8E9393", "#E3E5E4"], ["Plum", "#8E5E7E", "#E8DCE6"], ["Forest Gray", "#8E978F", "#E4E7E3"], ["Sienna Brown", "#8C7A72", "#E6DFDB"], ["Grape", "#8D82B8", "#E3E0F0"], ["Emerald Blue", "#5F8A8C", "#DDE7E6"]], "mirror": [["Silver", "#6F8099", "#C9D3DF"], ["Gold", "#B8962A", "#EAD77A"], ["Blue", "#2E6DB5", "#7FB2E6"], ["Purple", "#4A3A86", "#8E7CC8"]]};
  var SUN_GROUPS = [['solid', 'Solid'], ['gradient', 'Gradient'], ['mirror', 'Mirror'], ['custom', 'Custom']];
  var SUN_DARK = {
    light: ['Light', '25%', 'Fashion and indoors. Not for bright sun.', 0.35],
    medium: ['Medium', '50%', 'Everyday, overcast and city days.', 0.6],
    dark: ['Dark', '80%', 'Full sun, beach and water.', 0.85]
  };
  var SUN_USES = [
    { id: 'drive', label: 'Driving', kind: 'pol', pcolor: 'grey', why: 'Polarized Grey keeps colors true and cuts glare off the road and windshields.' },
    { id: 'water', label: 'Beach and water', kind: 'pol', pcolor: 'green', why: 'Polarized Green kills glare off water and sand and adds contrast in bright light.' },
    { id: 'city', label: 'Everyday in the city', kind: 'tint', group: 'gradient', tint: 'Sienna Brown', dark: 'medium', why: 'A medium brown gradient: shade on top, a clear view of your phone below.' },
    { id: 'style', label: 'Style, indoors and evenings', kind: 'tint', group: 'solid', tint: 'Plum', dark: 'light', why: 'A light solid tint is all look. Keep it for indoors and low sun.' }
  ];

  function range(from, to, step) {
    var out = [];
    for (var v = from; v <= to + 1e-9; v += step) out.push(v);
    return out;
  }
  function fmtPower(v) {
    if (Math.abs(v) < 1e-9) return '0.00';
    return (v > 0 ? '+' : '') + v.toFixed(2);
  }
  var SPH = range(-16, 10, 0.25).map(fmtPower);
  var CYL = range(-6, 6, 0.25).map(fmtPower);
  var ADD = range(0.75, 3.5, 0.25).map(fmtPower);
  var PD = range(50, 80, 1).map(function (v) { return String(v); });
  var PD_MONO = range(24, 40, 0.5).map(function (v) { return v.toFixed(1); });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    var n = (cents || 0) / 100;
    var withDecimals = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var f = format || '${{amount}}';
    return f
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals)
      .replace(/<[^>]*>/g, '');
  }

  function init(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-rxc-json]').textContent); }
    catch (e) { console.error('[rxc] could not read configurator data', e); return; }

    var moneyFormat = root.getAttribute('data-money-format');
    var money = function (c) { return formatMoney(c, moneyFormat); };
    var addLabel = function (c) { return c > 0 ? '+' + money(c) : 'Included'; };

    var line = data.line === 'sun' ? 'sun' : 'optical';
    var options = (data.options || [])
      .filter(function (o) { return o.variant; })
      .filter(function (o) { var l = o.line || 'optical'; return l === line || l === 'both'; })
      .map(function (o) {
        o.applies = String(o.appliesTo || '').split(',')
          .map(function (s) { return s.trim().toLowerCase(); })
          .filter(Boolean);
        o.code = CODE_BY_SKU[(o.sku || '').toUpperCase()] || CODE_BY_LABEL[(o.label || '').trim().toLowerCase()] || o.id;
        o.groupKey = o.group ? 'g:' + o.group.toLowerCase() : 'o:' + o.id;
        return o;
      })
      .sort(function (a, b) { return a.sort - b.sort; });

    function inStep(step) { return options.filter(function (o) { return o.step === step; }); }
    function byId(id) { return options.filter(function (o) { return o.id === id; })[0] || null; }

    // ---------- DOM ----------
    var $ = function (sel) { return root.querySelector(sel); };
    var elSteps = $('[data-rxc-steps]');
    var elBody = $('[data-rxc-body]');
    var elTotal = $('[data-rxc-total]');
    var elError = $('[data-rxc-error]');
    var elNext = $('[data-rxc-next]');
    var elBack = $('[data-rxc-back]');

    // photo carousel: swipe (touch/trackpad), drag (mouse), arrows, thumbnails, keyboard
    (function () {
      var track = root.querySelector('[data-rxc-track]');
      if (!track) return;
      var slides = track.children.length;
      var thumbs = root.querySelectorAll('[data-rxc-thumb]');
      var dots = root.querySelectorAll('.rxc__dotImg');
      var prev = root.querySelector('[data-rxc-prev]');
      var next = root.querySelector('[data-rxc-nextimg]');
      var index = function () { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); };
      var goTo = function (i) {
        i = Math.max(0, Math.min(slides - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      };
      var sync = function () {
        var i = index();
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides - 1;
      };
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-rxc-thumb'), 10)); }); });
      if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
      if (next) next.addEventListener('click', function () { goTo(index() + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
      });
      // mouse drag (touch and trackpads swipe natively)
      var startX = 0, startLeft = 0, dragging = false, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || slides < 2 || track.scrollWidth <= track.clientWidth + 5) return;
        dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      var end = function (e) {
        if (!dragging) return;
        dragging = false; track.classList.remove('is-dragging');
        var dx = e.clientX - startX, w = track.clientWidth, base = Math.round(startLeft / w);
        goTo(Math.abs(dx) > w * 0.15 ? base + (dx < 0 ? 1 : -1) : base);
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      window.addEventListener('resize', function () { track.scrollLeft = index() * track.clientWidth; });
      sync();
    })();

    // ---------- state ----------
    var visions = inStep('vision');
    var S = {
      i: 0,
      vision: visions[0] ? visions[0].id : null,
      lens: null,
      groupPick: {},
      thick: null,
      thickTouched: false,
      method: 'enter',
      power: '',
      file: null,
      rx: { odSph: '0.00', osSph: '0.00', odCyl: '0.00', osCyl: '0.00', odAxis: '', osAxis: '', odAdd: '', osAdd: '', pd: '63', pdR: '', pdL: '', twoPd: false },
      busy: false,
      sun: { pcolor: 'grey', group: 'solid', tint: 'Gray 1', dark: 'medium', custom: '', use: '', help: false }
    };

    function visionCode() { var v = byId(S.vision); return v ? v.code : 'sv'; }
    function needsRx() { var c = visionCode(); return c === 'sv' || c === 'prog'; }
    function applies(o) { return o.applies.length === 0 || o.applies.indexOf(visionCode()) !== -1; }
    function lensChoices() { return inStep('lenses').filter(applies); }
    function thickChoices() { return inStep('thickness').filter(applies); }

    function steps() {
      var c = visionCode();
      var list = [{ key: 'vision', name: 'Vision' }, { key: 'lenses', name: 'Lenses' }];
      if (c === 'readers') list.push({ key: 'rx', name: 'Strength' });
      else if (c !== 'plano') list.push({ key: 'rx', name: 'Prescription' });
      list.push({ key: 'review', name: 'Review' });
      return list;
    }
    function current() { return steps()[S.i] || steps()[0]; }

    // keep choices valid when the vision type changes
    function normalise() {
      var lc = lensChoices();
      if (!lc.some(function (o) { return o.id === S.lens; })) S.lens = lc[0] ? lc[0].id : null;
      var tc = thickChoices();
      if (!tc.length) { S.thick = null; }
      else if (!S.thickTouched || !tc.some(function (o) { return o.id === S.thick; })) {
        S.thick = tc[recommendedIndex()] ? tc[recommendedIndex()].id : tc[0].id;
      }
      if (S.i >= steps().length) S.i = steps().length - 1;
    }

    function strongestPower() {
      if (S.method !== 'enter' || !needsRx()) return 0;
      var r = S.rx;
      return Math.max.apply(null, [r.odSph, r.osSph, r.odCyl, r.osCyl].map(function (v) { return Math.abs(parseFloat(v) || 0); }));
    }
    function strongestLabel() {
      var r = S.rx, best = '0.00', max = -1;
      [r.odSph, r.osSph, r.odCyl, r.osCyl].forEach(function (v) {
        var a = Math.abs(parseFloat(v) || 0);
        if (a > max) { max = a; best = v; }
      });
      return best;
    }
    function recommendedIndex() {
      var p = strongestPower(), tc = thickChoices(), rules = data.rules || {};
      var idx = 0;
      if (p >= (parseFloat(rules.thinnest) || 5.5)) idx = 2;
      else if (p >= (parseFloat(rules.thin) || 4)) idx = 1;
      return Math.min(idx, Math.max(tc.length - 1, 0));
    }

    function chosenLines() {
      var lines = [];
      [S.vision, S.lens, S.thick].forEach(function (id) { var o = byId(id); if (o) lines.push(o); });
      return lines;
    }
    function total() {
      return chosenLines().reduce(function (sum, o) { return sum + (o.price || 0); }, data.frame.price || 0);
    }

    // ---------- render ----------
    function renderSteps() {
      var list = steps();
      elSteps.innerHTML = list.map(function (s, i) {
        var cls = i === S.i ? ' is-on' : (i < S.i ? ' is-done' : '');
        var dot = i < S.i ? '&#10003;' : String(i + 1);
        var go = i < S.i ? ' data-go="' + i + '"' : '';
        return (i ? '<span class="rxc__rule" aria-hidden="true"></span>' : '') +
          '<button type="button" class="rxc__step' + cls + '"' + go + (i === S.i ? ' aria-current="step"' : '') + '>' +
          '<span class="rxc__dot">' + dot + '</span><span class="rxc__stepName">' + esc(s.name) + '</span></button>';
      }).join('');
    }

    function chipsHtml() {
      var bits = [];
      var list = steps();
      var v = byId(S.vision), l = byId(S.lens);
      if (S.i > 0 && v) bits.push({ label: v.label, go: 0 });
      if (S.i > 1 && l) bits.push({ label: lensName(l), go: 1 });
      if (!bits.length) return '';
      return '<div class="rxc__chips">' + bits.map(function (b) {
        return '<button type="button" class="rxc__chip" data-go="' + b.go + '">&#10003; ' + esc(b.label) + ' <b>Change</b></button>';
      }).join('') + '</div>';
    }

    function tintName(o) {
      var t = String(o.variantTitle || '');
      var base = String(o.label || '');
      if (base && t.toLowerCase().indexOf(base.toLowerCase()) === 0) t = t.slice(base.length);
      t = t.replace(/^[\s\-–—·+]+/, '').trim();
      return t || o.variantTitle || o.label;
    }
    function lensName(o) {
      var members = lensChoices().filter(function (x) { return x.groupKey === o.groupKey; });
      return members.length > 1 ? o.label + ' · ' + tintName(o) : o.label;
    }

    function card(o, selected, extra, priceCents, icon) {
      return '<button type="button" class="rxc__card' + (selected ? ' is-on' : '') + '" aria-pressed="' + selected + '" data-pick="' + esc(o.id) + '">' +
        '<span class="rxc__radio" aria-hidden="true"></span>' + (icon || '') +
        '<span class="rxc__cardText"><span class="rxc__cardTitle">' + esc(o.label) +
        (o.tag ? '<span class="rxc__tag">' + esc(o.tag) + '</span>' : '') + '</span>' +
        (o.description ? '<span class="rxc__cardDesc">' + esc(o.description) + '</span>' : '') + (extra || '') + '</span>' +
        '<span class="rxc__price">' + addLabel(priceCents == null ? o.price : priceCents) + '</span></button>';
    }

    function renderVision() {
      return '<h2 class="rxc__h2">What are these for?</h2>' +
        '<p class="rxc__p">Not sure? Look at your prescription. A number in the ADD column means Progressive is the right call.</p>' +
        inStep('vision').map(function (o) { return card(o, o.id === S.vision); }).join('') +
        fastTrackHtml();
    }

    // Non-prescription fast track: ready-to-wear lenses, straight to Review
    function fastLens() {
      if (visionCode() !== 'plano') return null;
      if (line === 'sun') return sunLensOf('pol');
      return lensChoices().filter(function (o) {
        return /clear/.test(((o.sku || '') + ' ' + (o.label || '')).toLowerCase());
      })[0] || null;
    }
    function fastTrackHtml() {
      var l = fastLens();
      if (!l) return '';
      var what = line === 'sun'
        ? 'Grey polarized lenses with 100% UV protection.'
        : 'Clear anti-reflective lenses with 100% UV protection.';
      return '<div class="rxc__fast"><div class="rxc__fastText"><strong>Ready to wear?</strong><span>' + what + ' ' +
        (l.price > 0 ? '+' + money(l.price) : 'Included') + '. Skip straight to review.</span></div>' +
        '<button type="button" class="rxc__fastBtn" data-fast="' + esc(l.id) + '">Skip to review</button></div>';
    }

    // ---------- animated lens icons ----------
    // A pair of lens shapes in a thin frame. 'demo' modes loop through looks; 'static' shows the customer's pick.
    function lensPair(mode, layers, size) {
      var inner = layers.map(function (l) {
        return '<b style="background:' + l.bg + (l.op != null ? ';opacity:' + l.op : '') + '"></b>';
      }).join('') + (mode === 'pol' ? '<s></s>' : '');
      return '<span class="rxc__li rxc__li--' + mode + (size ? ' rxc__li--' + size : '') + '" aria-hidden="true"><i>' + inner + '</i><i>' + inner + '</i></span>';
    }
    function lensIconFor(o, selected) {
      if (line === 'sun') {
        var k = sunKind(o);
        if (selected) { var c = sunColor(); if (c) return lensPair(/^linear-gradient\(160deg/.test(c.bg) ? 'mirror' : 'static', [{ bg: c.bg, op: c.op }]); }
        if (k === 'pol') return lensPair('pol', SUN_POL.map(function (p) { return { bg: p[2] }; }));
        if (k === 'tint') return lensPair('cycle', [
          { bg: '#6A2A55' },
          { bg: 'linear-gradient(180deg,#6E4A3C 8%,rgba(230,223,219,.35) 92%)' },
          { bg: 'linear-gradient(160deg,#2E6DB5,#7FB2E6)' }
        ]);
        return '';
      }
      var key = ((o.sku || '') + ' ' + (o.label || '') + ' ' + (o.variantTitle || '')).toLowerCase();
      if (/adapt|adpt|photochrom|transition/.test(key)) {
        var col = o.swatch || (/brn|brown/.test(key) ? '#5B3A24' : '#2F3336');
        return lensPair(/screen|blue ?light/.test(key) ? 'adaptscreen' : 'adapt', [{ bg: col }]);
      }
      if (/screen|blue ?light/.test(key)) return lensPair('screen', [{ bg: 'rgba(232,217,160,.45)' }]);
      return lensPair('clear', [{ bg: 'rgba(205,225,235,.35)' }]);
    }
    // Lens edge profile for the thickness choices: thicker edges for standard, slimmer for high index.
    function edgeIcon(o) {
      var k = ((o.sku || '') + ' ' + (o.label || '')).toLowerCase();
      var e = /1\.74|174|thinnest/.test(k) ? 5 : /1\.67|167|thin/.test(k) ? 8.5 : 13;
      var t = 14 - e / 2, b = 14 + e / 2;
      return '<svg class="rxc__edge" viewBox="0 0 60 28" aria-hidden="true"><path d="M4,' + t + ' Q30,' + (11 + e / 2) + ' 56,' + t + ' L56,' + b + ' Q30,' + (17 - e / 2) + ' 4,' + b + ' Z"/></svg>';
    }
    function lensOne(bg, op, mirror) {
      return '<span class="rxc__l1' + (mirror ? ' is-mirror' : '') + '" aria-hidden="true"><b style="background:' + bg + ';opacity:' + op + '"></b></span>';
    }

    // ---------- SUNSPECS lens color ----------
    function sunKind(o) {
      if (!o) return '';
      var k = ((o.sku || '') + ' ' + (o.label || '') + ' ' + (o.variantTitle || '')).toLowerCase();
      if (/tint/.test(k)) return 'tint';
      if (/polar/.test(k)) return 'pol';
      return '';
    }
    function sunLensOf(kind) { return lensChoices().filter(function (o) { return sunKind(o) === kind; })[0] || null; }
    function sunTintRow() {
      var g = S.sun.group;
      if (g === 'custom') return null;
      var list = SUN_TINTS[g] || SUN_TINTS.solid;
      return list.filter(function (t) { return t[0] === S.sun.tint; })[0] || list[0];
    }
    function sunColor() {
      var kind = sunKind(byId(S.lens));
      if (kind === 'pol') {
        var p = SUN_POL.filter(function (c) { return c[0] === S.sun.pcolor; })[0] || SUN_POL[0];
        return { kind: 'pol', name: p[1] + ' polarized', bg: p[2], op: 0.9, swatch: p[2], color: p[1] };
      }
      if (kind === 'tint') {
        var g = S.sun.group, d = SUN_DARK[S.sun.dark] || SUN_DARK.medium;
        if (g === 'custom') {
          return { kind: 'tint', name: 'Custom' + (S.sun.custom ? ': ' + S.sun.custom : ' shade'), bg: 'linear-gradient(180deg,#9A8F86,#D8D1CA)', op: d[3], swatch: 'linear-gradient(180deg,#9A8F86,#D8D1CA)', color: 'Custom', dark: d };
        }
        var t = sunTintRow(), groupName = (SUN_GROUPS.filter(function (x) { return x[0] === g; })[0] || ['', ''])[1];
        var bg = t.length > 2 ? 'linear-gradient(' + (g === 'mirror' ? '160deg' : '180deg') + ',' + t[1] + ',' + t[2] + ')' : t[1];
        return { kind: 'tint', name: groupName + ' ' + t[0] + (g === 'mirror' ? '' : ' · ' + d[0] + ' ' + d[1]), bg: bg, op: g === 'mirror' ? 0.95 : d[3], swatch: bg, color: groupName + ' ' + t[0], dark: g === 'mirror' ? null : d };
      }
      return null;
    }
    function sunHelpHtml() {
      var h = '<div class="rxc__help"><button type="button" class="rxc__helpBtn" data-sunhelp aria-expanded="' + S.sun.help + '">Not sure? Help me choose<span aria-hidden="true">' + (S.sun.help ? '&minus;' : '+') + '</span></button>';
      if (S.sun.help) {
        var use = SUN_USES.filter(function (u) { return u.id === S.sun.use; })[0];
        h += '<div class="rxc__helpBody"><span class="rxc__p" style="margin:0;font-size:13px">Where will you wear them most?</span><div class="rxc__uses" role="group" aria-label="Where you will wear them">' +
          SUN_USES.map(function (u) { var on = u.id === S.sun.use; return '<button type="button" class="rxc__use' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sunuse="' + u.id + '">' + esc(u.label) + '</button>'; }).join('') + '</div>' +
          (use ? '<div class="rxc__why" role="status"><span><strong>We picked it for you.</strong> ' + esc(use.why) + '</span></div>' : '') + '</div>';
      }
      return h + '</div>';
    }
    function sunColorHtml() {
      var c = sunColor();
      if (!c) return '';
      var h = '<div class="rxc__color"><div class="rxc__colorHead">' + lensPair(/^linear-gradient\(160deg/.test(c.bg) ? 'mirror' : 'static', [{ bg: esc(c.bg), op: c.op }], 'lg') + '<div><span class="rxc__label">LENS COLOR</span><strong>' + esc(c.name) + '</strong></div></div>';
      if (c.kind === 'pol') {
        h += '<div class="rxc__pills" role="group" aria-label="Polarized color">' + SUN_POL.map(function (p) {
          var on = p[0] === S.sun.pcolor;
          return '<button type="button" class="rxc__pill' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sun="pcolor:' + p[0] + '">' + lensOne(p[2], 0.9, false) + p[1] + '</button>';
        }).join('') + '</div><p class="rxc__fine">Polarized lenses come in grey, brown or green. For other colors, choose Tinted.</p>';
      } else {
        h += '<div class="rxc__pills" role="group" aria-label="Tint style">' + SUN_GROUPS.map(function (g) {
          var on = g[0] === S.sun.group;
          return '<button type="button" class="rxc__pill' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sun="group:' + g[0] + '">' + g[1] + '</button>';
        }).join('') + '</div>';
        if (S.sun.group !== 'custom') {
          var cur = sunTintRow();
          h += '<div class="rxc__swatches" role="group" aria-label="Tint colors">' + SUN_TINTS[S.sun.group].map(function (t) {
            var on = t[0] === cur[0];
            var bg = t.length > 2 ? 'linear-gradient(' + (S.sun.group === 'mirror' ? '160deg' : '180deg') + ',' + t[1] + ',' + t[2] + ')' : t[1];
            return '<button type="button" class="rxc__swatch' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" aria-label="' + esc(t[0]) + '" data-sun="tint:' + esc(t[0]) + '"><i class="' + (S.sun.group === 'mirror' ? 'is-mirror' : '') + '" style="background:' + bg + '"></i>' + esc(t[0]) + '</button>';
          }).join('') + '</div>';
        } else {
          h += '<label style="display:flex;flex-direction:column;gap:6px;font-size:13px;font-weight:600">Describe the color you want<input type="text" class="rxc__customIn" data-suncustom maxlength="120" placeholder="e.g. light rose gradient, or match a photo" value="' + esc(S.sun.custom) + '"></label>' +
            '<p class="rxc__fine">We can tint almost any color. We\'ll confirm the shade with you by email before your lenses are cut.</p>';
        }
        if (S.sun.group === 'mirror') {
          h += '<p class="rxc__fine">Mirror coatings sit over a dark grey base, made for full sun.</p>';
        } else {
          h += '<div style="display:flex;flex-direction:column;gap:8px"><span style="font-size:13px;font-weight:600">How dark?</span><div class="rxc__darks" role="group" aria-label="Tint darkness">' +
            ['light', 'medium', 'dark'].map(function (k) {
              var d = SUN_DARK[k], on = k === S.sun.dark;
              var tb = c.bg;
              return '<button type="button" class="rxc__dark' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sun="dark:' + k + '">' + lensOne(esc(tb), d[3], false) + '<b>' + d[0] + ' <span>' + d[1] + '</span></b><small>' + esc(d[2]) + '</small></button>';
            }).join('') + '</div><p class="rxc__fine">Any tint can be made lighter or darker. Gradients fade from this darkness at the top to clear at the bottom.</p></div>';
        }
      }
      return h + '</div>';
    }

    function renderLenses() {
      var groups = [], seen = {};
      lensChoices().forEach(function (o) {
        if (!seen[o.groupKey]) { seen[o.groupKey] = []; groups.push(seen[o.groupKey]); }
        seen[o.groupKey].push(o);
      });
      var html = chipsHtml() +
        '<h2 class="rxc__h2">Choose your lenses</h2>' +
        '<p class="rxc__p">' + (line === 'sun' ? '100% UV protection and scratch resistant, whatever you pick.' : 'Every pair is scratch-resistant with anti-reflective coating and 100% UV protection.') + '</p>' +
        (line === 'sun' ? sunHelpHtml() : '');
      groups.forEach(function (members) {
        var selectedInGroup = members.filter(function (m) { return m.id === S.lens; })[0];
        var shown = selectedInGroup || byId(S.groupPick[members[0].groupKey]) || members[0];
        var extra = '';
        if (members.length > 1) {
          extra = '<span class="rxc__tints" role="group" aria-label="Tint">' + members.map(function (m) {
            var on = m.id === shown.id;
            return '<span class="rxc__tint' + (on ? ' is-on' : '') + '" role="button" tabindex="0" aria-pressed="' + on + '" data-tint="' + esc(m.id) + '">' +
              (m.swatch ? lensOne(esc(m.swatch), 0.9, false) : '') + esc(tintName(m)) + '</span>';
          }).join('') + '</span>';
        }
        html += card(shown, !!selectedInGroup, extra, null, lensIconFor(shown, !!selectedInGroup));
      });
      if (line === 'sun') html += sunColorHtml();
      return html;
    }

    function selectHtml(key, list, label, value, placeholder) {
      return '<select data-rx="' + key + '" aria-label="' + esc(label) + '">' +
        (placeholder ? '<option value="">' + esc(placeholder) + '</option>' : '') +
        list.map(function (v) { return '<option value="' + v + '"' + (v === value ? ' selected' : '') + '>' + v + '</option>'; }).join('') +
        '</select>';
    }

    function renderRx() {
      var html = chipsHtml();
      if (visionCode() === 'readers') {
        return html + '<h2 class="rxc__h2">Pick your strength</h2>' +
          '<p class="rxc__p">Readers magnify up close. If you already own readers, the number is usually printed on the inside of the temple.</p>' +
          '<div class="rxc__row"><label for="rxc-power">Strength</label>' +
          '<select id="rxc-power" data-power>' + '<option value="">Choose…</option>' +
          (line === 'sun' ? READER_POWERS_SUN : READER_POWERS).map(function (p) { return '<option' + (p === S.power ? ' selected' : '') + '>' + p + '</option>'; }).join('') +
          '</select></div>';
      }
      var prog = visionCode() === 'prog';
      var r = S.rx;
      html += '<h2 class="rxc__h2">Add your prescription</h2>' +
        '<div class="rxc__tabs" role="tablist" aria-label="How to add your prescription">' +
        [['enter', 'Type it in'], ['upload', 'Upload a photo'], ['later', 'Send it later']].map(function (t) {
          var on = S.method === t[0];
          return '<button type="button" role="tab" aria-selected="' + on + '" class="rxc__tab' + (on ? ' is-on' : '') + '" data-method="' + t[0] + '">' + t[1] + '</button>';
        }).join('') + '</div>';

      if (S.method === 'enter') {
        var fld = function (label, control) {
          return '<div class="rxc__fld"><span class="rxc__col" aria-hidden="true">' + label + '</span>' + control + '</div>';
        };
        var eye = function (side, name, code) {
          var cyl = r[side + 'Cyl'];
          return '<div class="rxc__eyeRow"><div class="rxc__eye">' + name + '<span>' + code + '</span></div>' +
            '<div class="rxc__fields' + (prog ? '' : ' no-add') + '">' +
            fld('SPH', selectHtml(side + 'Sph', SPH, name + ' SPH', r[side + 'Sph'])) +
            fld('CYL', selectHtml(side + 'Cyl', CYL, name + ' CYL', cyl)) +
            fld('AXIS', '<input type="text" inputmode="numeric" maxlength="3" data-rx="' + side + 'Axis" aria-label="' + name + ' axis" placeholder="' + (parseFloat(cyl) ? '1–180' : '—') + '" value="' + esc(r[side + 'Axis']) + '">') +
            (prog ? fld('ADD', selectHtml(side + 'Add', ADD, name + ' ADD', r[side + 'Add'], 'Choose')) : '') +
            '</div></div>';
        };
        html += eye('od', 'Right eye', 'OD') + eye('os', 'Left eye', 'OS') +
          '<div class="rxc__row"><label>Pupillary distance (PD)</label>' +
          (r.twoPd
            ? selectHtml('pdR', PD_MONO, 'Right PD', r.pdR, 'Right') + selectHtml('pdL', PD_MONO, 'Left PD', r.pdL, 'Left')
            : selectHtml('pd', PD, 'Pupillary distance', r.pd)) +
          '<label class="rxc__check"><input type="checkbox" data-twopd' + (r.twoPd ? ' checked' : '') + '>I have two PD numbers</label></div>';
      } else if (S.method === 'upload') {
        html += '<div class="rxc__drop">' +
          '<strong>' + (S.file ? esc(S.file.name) : 'Add a photo of your prescription') + '</strong>' +
          '<span>' + (S.file ? 'Attached. An optician will confirm your numbers and thickness.' : 'JPG, PNG, HEIC or PDF. Make sure the date and doctor\'s signature are visible.') + '</span>' +
          '<label class="rxc__file">' + (S.file ? 'Choose a different file' : 'Browse files') +
          '<input type="file" data-file accept="image/*,application/pdf" hidden></label></div>' +
          '<div class="rxc__row"><label for="rxc-pd-up">PD (optional)</label>' +
          '<select id="rxc-pd-up" data-rx="pd"><option value="">Not sure</option>' + PD.map(function (v) { return '<option' + (v === r.pd ? ' selected' : '') + '>' + v + '</option>'; }).join('') + '</select></div>';
      } else {
        html += '<div class="rxc__box"><strong>Check out now, send it after</strong>' +
          'We\'ll email you to upload your prescription or share your eye doctor\'s contact. Your lenses aren\'t cut until an optician has checked it.</div>';
      }
      html += '<div data-thick></div>';
      return html;
    }

    function thickHtml() {
      var tc = thickChoices();
      if (!tc.length) return '';
      var rec = recommendedIndex();
      var showRec = S.method === 'enter' && rec > 0;
      var html = '';
      if (showRec) {
        html += '<div class="rxc__note" role="status"><div><strong>At ' + esc(strongestLabel()) + ', we recommend ' + esc(tc[rec].label) + '.</strong> ' + esc((data.rules && data.rules.note) || '') + '</div></div>';
      }
      html += '<div style="font-size:15px;font-weight:600;margin-top:4px">Lens thickness</div><div class="rxc__segs">' +
        tc.map(function (o, i) {
          var on = o.id === S.thick;
          return '<button type="button" class="rxc__seg' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-thick-pick="' + esc(o.id) + '">' + edgeIcon(o) +
            '<b>' + esc(o.label) + (showRec && i === rec ? '<span class="rxc__tag">RECOMMENDED</span>' : '') + '</b>' +
            '<span>' + addLabel(o.price) + '</span></button>';
        }).join('') + '</div>';
      if (S.method !== 'enter' && tc.length > 1) {
        html += '<p class="rxc__p" style="margin-top:4px">Not sure? Leave Standard and our optician will suggest a thinner lens if your prescription needs one.</p>';
      }
      return html;
    }

    function rxSummary() {
      var c = visionCode(), r = S.rx;
      if (c === 'readers') return { title: 'Strength ' + (S.power || '—'), table: '' };
      if (c === 'plano') return { title: 'No prescription needed', table: '' };
      if (S.method === 'upload') return { title: 'Photo uploaded', sub: S.file ? S.file.name : '', table: '' };
      if (S.method === 'later') return { title: 'Sending it after checkout', table: '' };
      var prog = c === 'prog';
      var pd = r.twoPd ? (r.pdR + ' / ' + r.pdL) : r.pd;
      var table = '<table class="rxc__rxTable"><tr><th></th><th>SPH</th><th>CYL</th><th>AXIS</th>' + (prog ? '<th>ADD</th>' : '') + '<th>PD</th></tr>' +
        '<tr><th>OD</th><td>' + esc(r.odSph) + '</td><td>' + esc(r.odCyl) + '</td><td>' + esc(r.odAxis || '—') + '</td>' + (prog ? '<td>' + esc(r.odAdd) + '</td>' : '') + '<td>' + esc(pd) + '</td></tr>' +
        '<tr><th>OS</th><td>' + esc(r.osSph) + '</td><td>' + esc(r.osCyl) + '</td><td>' + esc(r.osAxis || '—') + '</td>' + (prog ? '<td>' + esc(r.osAdd) + '</td>' : '') + '<td></td></tr></table>';
      return { title: 'Typed in', table: table };
    }

    function renderReview() {
      var list = steps();
      var rxIndex = list.map(function (s) { return s.key; }).indexOf('rx');
      var v = byId(S.vision), l = byId(S.lens), t = byId(S.thick);
      function row(label, value, sub, price, go) {
        return '<div class="rxc__sum"><span class="rxc__label">' + label + '</span>' +
          '<span class="rxc__sumVal">' + esc(value) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span>' +
          '<span class="rxc__price">' + price + '</span>' +
          (go == null ? '<span></span>' : '<button type="button" class="rxc__edit" data-go="' + go + '">Edit</button>') + '</div>';
      }
      var html = '<h2 class="rxc__h2">Review your ' + esc(data.frame.title.replace(/\(pilot\)/i, '').trim()) + '</h2>';
      html += row('FRAME', data.frame.title.replace(/\(pilot\)/i, '').trim(), data.frame.variantTitle === 'Default Title' ? '' : data.frame.variantTitle, money(data.frame.price), null);
      if (v) html += row('VISION', v.label, '', addLabel(v.price), 0);
      if (l) html += row('LENSES', lensName(l), '', addLabel(l.price), 1);
      var sc = line === 'sun' ? sunColor() : null;
      if (sc) html += row('LENS COLOR', sc.color, sc.dark ? sc.dark[0] + ' ' + sc.dark[1] + (S.sun.group === 'gradient' ? ' at the top, fading to clear' : '') : (sc.kind === 'tint' && S.sun.group === 'mirror' ? 'Mirror over a dark grey base' : ''), 'Included', 1);
      if (sc && S.sun.group === 'custom' && sc.kind === 'tint') html += '<div class="rxc__note" style="margin-top:12px"><div><strong>Custom shade.</strong> We\'ll email you to confirm the color before your lenses are cut.</div></div>';
      if (t) html += row('THICKNESS', t.label, '', addLabel(t.price), rxIndex);
      if (rxIndex !== -1) {
        var rs = rxSummary();
        html += '<div class="rxc__sum" style="display:block"><div style="display:flex;justify-content:space-between;align-items:center">' +
          '<span style="display:flex;gap:12px;align-items:baseline"><span class="rxc__label" style="width:120px">' + (visionCode() === 'readers' ? 'STRENGTH' : 'PRESCRIPTION') + '</span>' +
          '<span class="rxc__sumVal">' + esc(rs.title) + (rs.sub ? '<small>' + esc(rs.sub) + '</small>' : '') + '</span></span>' +
          '<button type="button" class="rxc__edit" data-go="' + rxIndex + '">Edit</button></div>' + rs.table + '</div>';
      }
      if (visionCode() === 'prog') html += '<div class="rxc__note" style="margin-top:12px"><div><strong>Made from scratch.</strong> Progressive lenses are surfaced to your exact prescription and ship in 7–10 business days.</div></div>';
      if (visionCode() === 'plano') html += '<p class="rxc__p" style="margin-top:12px">Ready to wear, no prescription needed. Non-prescription pairs ship sooner than prescription orders.</p>';
      if (data.reviewNote && visionCode() !== 'plano') html += '<p class="rxc__p" style="margin-top:12px">' + esc(data.reviewNote) + '</p>';
      return html;
    }

    function render() {
      normalise();
      renderSteps();
      var key = current().key;
      elBody.innerHTML =
        key === 'vision' ? renderVision() :
        key === 'lenses' ? renderLenses() :
        key === 'rx' ? renderRx() : renderReview();
      refreshThick();
      refreshTotal();
      updatePreview();
      elBack.hidden = S.i === 0;
      var last = S.i === steps().length - 1;
      elNext.textContent = last ? (data.frame.available ? 'Add to cart' : 'Sold out') : 'Continue';
      elNext.disabled = (last && !data.frame.available) || S.busy;
      showError('');
    }
    function refreshThick() {
      var box = elBody.querySelector('[data-thick]');
      if (!box) return;
      if (!S.thickTouched) {
        var tc = thickChoices();
        if (tc.length) S.thick = tc[recommendedIndex()].id;
      }
      box.innerHTML = thickHtml();
    }
    var apAmt = root.querySelector('[data-rxc-afterpay-amt]');
    var apFallback = root.querySelector('[data-rxc-afterpay-fallback]');
    function refreshTotal() {
      elTotal.textContent = money(total());
      if (apAmt) apAmt.textContent = money(Math.round(total() / 4));
      // If Afterpay's own message is placed in the slot, hide our fallback line.
      var slot = root.querySelector('[data-rxc-afterpay]');
      if (slot && apFallback) {
        var official = slot.querySelector('afterpay-placement, square-placement, .afterpay-paragraph, [class*="afterpay-"]') ||
          (slot.nextElementSibling && /afterpay/i.test(slot.nextElementSibling.className + ' ' + slot.nextElementSibling.tagName) ? slot.nextElementSibling : null);
        apFallback.hidden = !!official;
      }
    }
    function showError(msg) { elError.textContent = msg; elError.hidden = !msg; }

    // ---------- validation ----------
    function validate() {
      var key = current().key;
      if (key === 'vision' && !S.vision) return 'Choose what these are for.';
      if (key === 'lenses' && !S.lens) return 'Choose a lens.';
      if (key === 'lenses' && line === 'sun' && sunKind(byId(S.lens)) === 'tint' && S.sun.group === 'custom' && !S.sun.custom.trim()) return 'Describe the custom color you want, or pick one from the chart.';
      if (key === 'rx') {
        var c = visionCode(), r = S.rx;
        if (c === 'readers') return S.power ? '' : 'Choose a strength.';
        if (S.method === 'upload' && !S.file) return 'Add a photo of your prescription, or pick "Send it later".';
        if (S.method === 'enter') {
          var axisOk = function (cyl, axis) {
            if (!parseFloat(cyl)) return true;
            var a = parseInt(axis, 10);
            return a >= 1 && a <= 180 && String(a) === String(axis).trim();
          };
          if (!axisOk(r.odCyl, r.odAxis)) return 'Right eye: enter an AXIS between 1 and 180 (needed when CYL isn\'t 0.00).';
          if (!axisOk(r.osCyl, r.osAxis)) return 'Left eye: enter an AXIS between 1 and 180 (needed when CYL isn\'t 0.00).';
          if (c === 'prog' && (!r.odAdd || !r.osAdd)) return 'Progressive lenses need the ADD value for both eyes.';
          if (r.twoPd && (!r.pdR || !r.pdL)) return 'Choose both PD numbers, or untick "I have two PD numbers".';
          if (!r.twoPd && !r.pd) return 'Choose your PD.';
        }
      }
      return '';
    }

    // ---------- cart ----------
    function frameProperties(pair) {
      var c = visionCode(), r = S.rx, p = {};
      var v = byId(S.vision), l = byId(S.lens), t = byId(S.thick);
      p._pair = pair;
      if (v) p['Vision'] = v.label;
      if (l) p['Lenses'] = lensName(l);
      if (t) p['Thickness'] = t.label;
      if (c === 'readers') p['Reader strength'] = S.power;
      if (c === 'sv' || c === 'prog') {
        p['Rx method'] = S.method === 'enter' ? 'Typed in' : S.method === 'upload' ? 'Uploaded photo' : 'Sending later';
        if (S.method === 'enter') {
          p['OD (right)'] = 'SPH ' + r.odSph + ' / CYL ' + r.odCyl + (r.odAxis ? ' / AXIS ' + r.odAxis : '') + (c === 'prog' ? ' / ADD ' + r.odAdd : '');
          p['OS (left)'] = 'SPH ' + r.osSph + ' / CYL ' + r.osCyl + (r.osAxis ? ' / AXIS ' + r.osAxis : '') + (c === 'prog' ? ' / ADD ' + r.osAdd : '');
        }
        var pd = r.twoPd ? (r.pdR && r.pdL ? r.pdR + ' / ' + r.pdL : '') : r.pd;
        if (pd) p['PD'] = pd;
      }
      var scp = line === 'sun' ? sunColor() : null;
      if (scp) {
        p['Lens color'] = scp.color;
        if (scp.dark) p['Darkness'] = scp.dark[0] + ' ' + scp.dark[1];
        if (scp.kind === 'tint' && S.sun.group === 'custom' && S.sun.custom) p['Custom color'] = S.sun.custom;
      }
      return p;
    }

    function addToCart() {
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var pair = 'rx' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var props = frameProperties(pair);

      var fd = new FormData();
      fd.append('id', data.frame.variant);
      fd.append('quantity', '1');
      Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
      if (S.method === 'upload' && S.file && needsRx()) fd.append('properties[Prescription photo]', S.file);

      var lensItems = chosenLines().map(function (o) {
        return { id: o.variant, quantity: 1, properties: { _pair: pair, _for: data.frame.title, _step: o.step } };
      });

      S.busy = true; elNext.disabled = true; elNext.textContent = 'Adding…';
      var frameKey = null;
      fetch(root_ + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function (item) {
          frameKey = item.key || (item.items && item.items[0] && item.items[0].key);
          if (!lensItems.length) return null;
          return fetch(root_ + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: lensItems })
          }).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); });
        })
        .then(function () { window.location.href = root_ + 'cart'; })
        .catch(function (err) {
          console.error('[rxc] add to cart failed', err);
          var undo = frameKey
            ? fetch(root_ + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: frameKey, quantity: 0 }) })
            : Promise.resolve();
          undo.then(function () {
            S.busy = false; render();
            showError((err && (err.description || err.message)) || 'Something went wrong adding your pair. Please try again, or chat with us.');
          });
        });
    }

    // ---------- live lens preview (light-adaptive / screen) ----------
    // Traces the lens openings from the first product photo in the browser, then tints them.
    var tintEl = root.querySelector('[data-rxc-tint]');
    var adaptEl = root.querySelector('[data-rxc-adapt]');
    var adaptBar = root.querySelector('[data-rxc-adaptbar]');
    var maskReady = false;
    var lensBand = null;

    function boxMorph(m, W, H, r, dilate) {
      var t = new Uint8Array(W * H), o = new Uint8Array(W * H), x, y, k, v, b;
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        v = dilate ? 0 : 1;
        for (k = -r; k <= r; k++) {
          b = (x + k < 0 || x + k >= W) ? 0 : m[y * W + x + k];
          if (dilate && b) { v = 1; break; }
          if (!dilate && !b) { v = 0; break; }
        }
        t[y * W + x] = v;
      }
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        v = dilate ? 0 : 1;
        for (k = -r; k <= r; k++) {
          b = (y + k < 0 || y + k >= H) ? 0 : t[(y + k) * W + x];
          if (dilate && b) { v = 1; break; }
          if (!dilate && !b) { v = 0; break; }
        }
        o[y * W + x] = v;
      }
      return o;
    }

    function segmentLenses(im) {
      var W = 360, H = Math.max(1, Math.round(im.naturalHeight * W / im.naturalWidth));
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H);
      var px = x.getImageData(0, 0, W, H).data, n = W * H, i, t, p;
      var lum = new Uint8Array(n), hist = new Array(256).fill(0);
      for (i = 0; i < n; i++) {
        var v = px[i * 4 + 3] < 40 ? 255 : Math.round(0.299 * px[i * 4] + 0.587 * px[i * 4 + 1] + 0.114 * px[i * 4 + 2]);
        lum[i] = v; hist[v]++;
      }
      var sum = 0; for (t = 0; t < 256; t++) sum += t * hist[t];
      var sumB = 0, wB = 0, best = 0, thr = 90;
      for (t = 0; t < 256; t++) {
        wB += hist[t]; if (!wB) continue;
        var wF = n - wB; if (!wF) break;
        sumB += t * hist[t];
        var mB = sumB / wB, mF = (sum - sumB) / wF, between = wB * wF * (mB - mF) * (mB - mF);
        if (between > best) { best = between; thr = t; }
      }
      thr = Math.max(40, Math.min(150, thr));
      var dark = new Uint8Array(n); for (i = 0; i < n; i++) dark[i] = lum[i] < thr ? 1 : 0;
      var outside = new Uint8Array(n), q = new Int32Array(n), qh = 0, qt = 0;
      var push = function (k) { if (!outside[k] && !dark[k]) { outside[k] = 1; q[qt++] = k; } };
      for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
      for (i = 0; i < H; i++) { push(i * W); push(i * W + W - 1); }
      while (qh < qt) { p = q[qh++]; var c0 = p % W; if (c0 > 0) push(p - 1); if (c0 < W - 1) push(p + 1); if (p >= W) push(p - W); if (p < n - W) push(p + W); }
      var lab = new Int32Array(n), sizes = [0], cx = [0], cur = 0;
      for (i = 0; i < n; i++) {
        if (dark[i] || outside[i] || lab[i]) continue;
        cur++; lab[i] = cur; qh = 0; qt = 0; q[qt++] = i;
        var size = 0, sx = 0;
        while (qh < qt) {
          p = q[qh++]; size++; sx += p % W;
          var col = p % W, nb = [col > 0 ? p - 1 : -1, col < W - 1 ? p + 1 : -1, p >= W ? p - W : -1, p < n - W ? p + W : -1];
          for (var j = 0; j < 4; j++) { var r = nb[j]; if (r >= 0 && !dark[r] && !outside[r] && !lab[r]) { lab[r] = cur; q[qt++] = r; } }
        }
        sizes.push(size); cx.push(sx / size);
      }
      var order = []; for (i = 1; i < sizes.length; i++) order.push(i);
      order.sort(function (a, b) { return sizes[b] - sizes[a]; });
      if (order.length < 2) return null;
      var A = order[0], B = order[1];
      if (sizes[A] < n * 0.015 || sizes[A] > n * 0.4 || sizes[B] < sizes[A] * 0.6) return null;
      if ((cx[A] - W / 2) * (cx[B] - W / 2) >= 0) return null;
      var m = new Uint8Array(n); for (i = 0; i < n; i++) m[i] = (lab[i] === A || lab[i] === B) ? 1 : 0;
      m = boxMorph(boxMorph(m, W, H, 4, true), W, H, 4, false);
      m = boxMorph(m, W, H, 2, true);
      var y0 = H, y1 = 0;
      for (i = 0; i < n; i++) if (m[i] && !outside[i]) { var yy = (i / W) | 0; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      if (y1 > y0) lensBand = [Math.round(y0 / H * 100), Math.round(y1 / H * 100)];
      var out = x.createImageData(W, H);
      for (i = 0; i < n; i++) out.data[i * 4 + 3] = (m[i] && !outside[i]) ? 255 : 0;
      x.putImageData(out, 0, 0);
      var c2 = document.createElement('canvas'); c2.width = W; c2.height = H;
      var x2 = c2.getContext('2d'); x2.filter = 'blur(0.8px)'; x2.drawImage(c, 0, 0);
      return c2.toDataURL('image/png');
    }

    function buildMask() {
      var shot = root.querySelector('[data-rxc-shot] img');
      if (!shot || !tintEl) return;
      var go = function () {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          var url = null;
          try { url = segmentLenses(im); } catch (err) { url = null; }
          if (!url) return;
          tintEl.style.webkitMaskImage = 'url(' + url + ')';
          tintEl.style.maskImage = 'url(' + url + ')';
          maskReady = true;
          updatePreview();
        };
        im.src = shot.currentSrc || shot.src;
      };
      if (shot.complete && shot.naturalWidth) go(); else shot.addEventListener('load', go, { once: true });
    }

    function lensEffect() {
      var l = byId(S.lens);
      if (!l) return { kind: 'none' };
      var key = ((l.sku || '') + ' ' + (l.label || '') + ' ' + (l.variantTitle || '')).toLowerCase();
      if (/adapt|adpt|photochrom|transition/.test(key)) {
        var brown = /brn|brown/.test(key);
        return { kind: 'adapt', color: l.swatch || (brown ? '#5B3A24' : '#2F3336') };
      }
      if (/screen|blue ?light/.test(key)) return { kind: 'screen', color: '#E8D9A0' };
      return { kind: 'none' };
    }

    var lastKind = 'none';
    function currentEffect() {
      if (line === 'sun') {
        var c = sunColor();
        if (!c) return { kind: 'none' };
        var bg = c.bg;
        if (lensBand && /^linear-gradient\(180deg,/.test(bg)) {
          var parts = bg.slice(bg.indexOf(',') + 1, -1).split(',');
          bg = 'linear-gradient(180deg,' + parts[0] + ' ' + lensBand[0] + '%,' + parts[1] + ' ' + lensBand[1] + '%)';
        }
        return { kind: 'static', bg: bg, op: c.op };
      }
      return lensEffect();
    }
    function updatePreview() {
      if (!tintEl) return;
      var e = currentEffect();
      var on = maskReady && e.kind !== 'none';
      tintEl.style.background = on ? (e.bg || e.color) : 'transparent';
      tintEl.classList.toggle('is-adapt', on && e.kind === 'adapt');
      tintEl.style.opacity = !on ? '0' : (e.kind === 'screen' ? '0.35' : (e.kind === 'static' ? String(e.op) : ''));
      if (adaptEl) adaptEl.hidden = !(on && e.kind === 'adapt');
      if (adaptBar && on && e.color) adaptBar.style.backgroundColor = e.color;
      if (on && e.kind !== lastKind) {
        var track = root.querySelector('[data-rxc-track]');
        if (track && track.scrollLeft > 0) track.scrollTo({ left: 0, behavior: 'smooth' });
      }
      lastKind = on ? e.kind : 'none';
    }

    // ---------- events ----------
    function go(i) { S.i = Math.max(0, Math.min(i, steps().length - 1)); render(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-go],[data-pick],[data-tint],[data-method],[data-thick-pick],[data-sun],[data-sunhelp],[data-sunuse],[data-fast]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-go')) { go(parseInt(t.getAttribute('data-go'), 10)); return; }
      if (t.hasAttribute('data-fast')) {
        S.lens = t.getAttribute('data-fast');
        if (line === 'sun') { S.sun.pcolor = 'grey'; S.sun.use = ''; }
        go(steps().length - 1); return;
      }
      if (t.hasAttribute('data-sunhelp')) { S.sun.help = !S.sun.help; render(); return; }
      if (t.hasAttribute('data-sunuse')) {
        var u = SUN_USES.filter(function (x) { return x.id === t.getAttribute('data-sunuse'); })[0];
        var lens = u && sunLensOf(u.kind);
        if (u && lens) {
          S.lens = lens.id; S.sun.use = u.id;
          if (u.pcolor) S.sun.pcolor = u.pcolor;
          if (u.group) { S.sun.group = u.group; S.sun.tint = u.tint; S.sun.dark = u.dark; }
        }
        render(); return;
      }
      if (t.hasAttribute('data-sun')) {
        var kv = t.getAttribute('data-sun'), at = kv.indexOf(':'), key = kv.slice(0, at), val = kv.slice(at + 1);
        S.sun[key] = val; S.sun.use = '';
        if (key === 'group' && val !== 'custom') S.sun.tint = SUN_TINTS[val][0][0];
        render(); return;
      }
      if (t.hasAttribute('data-tint')) {
        e.stopPropagation();
        var m = byId(t.getAttribute('data-tint'));
        S.groupPick[m.groupKey] = m.id; S.lens = m.id; render(); return;
      }
      if (t.hasAttribute('data-pick')) {
        var o = byId(t.getAttribute('data-pick'));
        if (o.step === 'vision') { S.vision = o.id; S.thickTouched = false; }
        else if (o.step === 'lenses') { S.lens = o.id; }
        render(); return;
      }
      if (t.hasAttribute('data-method')) { S.method = t.getAttribute('data-method'); S.thickTouched = false; render(); return; }
      if (t.hasAttribute('data-thick-pick')) { S.thick = t.getAttribute('data-thick-pick'); S.thickTouched = true; refreshThick(); refreshTotal(); }
    });

    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute && e.target.hasAttribute('data-tint')) { e.preventDefault(); e.target.click(); }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-rx')) {
        S.rx[t.getAttribute('data-rx')] = t.value.trim();
        var k = t.getAttribute('data-rx');
        if (/Cyl$/.test(k)) {
          var axis = root.querySelector('[data-rx="' + k.replace('Cyl', 'Axis') + '"]');
          if (axis) axis.placeholder = parseFloat(t.value) ? '1–180' : '—';
        }
        refreshThick(); refreshTotal(); showError('');
      } else if (t.hasAttribute('data-twopd')) {
        S.rx.twoPd = t.checked; render();
      } else if (t.hasAttribute('data-suncustom')) {
        S.sun.custom = t.value.trim(); render();
      } else if (t.hasAttribute('data-power')) {
        S.power = t.value; showError('');
      } else if (t.hasAttribute('data-file')) {
        var f = t.files && t.files[0];
        if (f && f.size > 20 * 1024 * 1024) { showError('That file is over 20 MB. Please choose a smaller photo.'); return; }
        S.file = f || null; render();
      }
    });

    elNext.addEventListener('click', function () {
      var msg = validate();
      if (msg) { showError(msg); return; }
      if (S.i === steps().length - 1) addToCart();
      else go(S.i + 1);
    });
    elBack.addEventListener('click', function () { go(S.i - 1); });

    if (!options.length) {
      elBody.innerHTML = '<p class="rxc__p">Lens options aren\'t set up yet for ' + (line === 'sun' ? 'sunglasses' : 'optical frames') + '. Check Content › Metaobjects › Lens option: entries must be Active, with Storefronts access on' + (line === 'sun' ? ', and Line set to sun' : '') + '.</p>';
      var all = data.options || [];
      var escT = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var rows = all.map(function (o) {
        var l = o.line || 'optical';
        var why = !o.variant ? 'Skipped: Price variant is empty' : (l === line || l === 'both') ? 'OK' : 'Skipped: Line is "' + (o.line || 'empty = optical') + '"';
        return '<tr><td>' + escT(o.label) + '</td><td>' + escT(o.step) + '</td><td>' + escT(o.line || '(empty)') + '</td><td>' + escT(o.sku || '(none)') + '</td><td>' + escT(why) + '</td></tr>';
      }).join('');
      elBody.innerHTML += '<p class="rxc__p" style="margin-top:12px"><b>Setup check:</b> this page received ' + all.length + ' lens entries.' + (all.length ? '' : ' None reached the page: entries may be Draft, or the definition\'s Storefronts access is off.') + '</p>' +
        (all.length ? '<div style="overflow-x:auto"><table style="font-size:11px;border-collapse:collapse;width:100%" cellpadding="4"><tr style="text-align:left;border-bottom:1px solid #ddd"><th>Label</th><th>Step</th><th>Line</th><th>SKU</th><th>Status</th></tr>' + rows + '</table></div>' : '');
      elNext.disabled = true;
      return;
    }
    render();
    buildMask();
  }

  document.querySelectorAll('[data-rxc]').forEach(init);
  // Talk To A Human: turn the "text" links into text-message links (built here, not stored in the theme file)
  document.querySelectorAll('[data-rxc-sms]').forEach(function (a) {
    var num = a.getAttribute('data-rxc-sms');
    var title = a.getAttribute('data-rxc-sms-title');
    var ios = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
    var link = ['sms', num].join(':');
    if (title) link += (ios ? '&' : '?') + 'body=' + encodeURIComponent('Hi Specsbylux, I have a question about ' + title);
    a.setAttribute('href', link);
  });
  // Talk To A Human: open/close the menu, plus a one-time teaser bubble
  function rxcSetCall(wrap, open) {
    var btn = wrap.querySelector('[data-rxc-calltoggle]'), menu = wrap.querySelector('[data-rxc-callmenu]'), teaser = wrap.querySelector('[data-rxc-teaser]');
    if (!btn || !menu) return;
    menu.hidden = !open;
    wrap.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && teaser) teaser.hidden = true;
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-rxc-call]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-rxc-calltoggle]'), menu = wrap.querySelector('[data-rxc-callmenu]');
      if (!btn || !menu) return;
      if (e.target.closest('[data-rxc-teaserx]') && wrap.contains(e.target)) {
        wrap.querySelector('[data-rxc-teaser]').hidden = true;
        try { sessionStorage.setItem('rxcTeaserSeen', '1'); } catch (err) {}
        return;
      }
      if (btn.contains(e.target) || (e.target.closest('[data-rxc-teaser]') && wrap.contains(e.target))) { rxcSetCall(wrap, menu.hidden); return; }
      if (!wrap.contains(e.target) || e.target.closest('a')) rxcSetCall(wrap, false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-rxc-call]').forEach(function (w) { rxcSetCall(w, false); });
  });
  setTimeout(function () {
    var seen = false;
    try { seen = sessionStorage.getItem('rxcTeaserSeen') === '1'; } catch (err) {}
    if (seen) return;
    document.querySelectorAll('[data-rxc-call]').forEach(function (wrap) {
      var teaser = wrap.querySelector('[data-rxc-teaser]'), menu = wrap.querySelector('[data-rxc-callmenu]');
      if (teaser && menu && menu.hidden) {
        teaser.hidden = false;
        try { sessionStorage.setItem('rxcTeaserSeen', '1'); } catch (err) {}
        setTimeout(function () { teaser.hidden = true; }, 12000);
      }
    });
  }, 6000);

})();